// 设置 默认市场 和 默认选中币对
// eslint-disable-next-line import/extensions
import myStorage from './mystorage';

function getSorterMaker(market) {
  let coinName = null;
  let coinSort = null;
  Object.keys(market).forEach((key) => {
    if (typeof coinSort !== 'number' || market[key].sort < coinSort) {
      coinName = key;
      coinSort = market[key].sort;
    }
  });

  return coinName;
}

// eslint-disable-next-line import/prefer-default-export
export const setDefaultMarket = (data) => {
  const markTitle = myStorage.get('markTitle');
  const homeMarkTitle = myStorage.get('homeMarkTitle');
  const marketIndex = data.maket_index;
  // 默认市场
  if (!markTitle || !data.market[markTitle]) {
    const defaultMarket = data.market[marketIndex] ? marketIndex
      : Object.keys(data.market)[0];
    myStorage.set('markTitle', defaultMarket);
  }
  // 首页默认市场
  if (!homeMarkTitle || !data.market[homeMarkTitle]) {
    const defaultMarket = data.market[marketIndex] ? marketIndex
      : Object.keys(data.market)[0];
    myStorage.set('homeMarkTitle', defaultMarket);
  }

  // 设置默认币对
  const sSymbolName = myStorage.get('sSymbolName') || null;
  const sMarkTitle = myStorage.get('markTitle');
  // 如果 myStorage 中没有默认币对  或者 市场列表中没有选中的币对
  try {
    if (!sSymbolName || !data.market[sMarkTitle][sSymbolName]) {
      // const defaultSymbol = data.market[sMarkTitle][sSymbolName] ? sSymbolName
      //   : Object.keys(data.market[sMarkTitle])[0];
      const defaultSymbol = data.market[sMarkTitle][sSymbolName] ? sSymbolName
        : getSorterMaker(data.market[sMarkTitle]);
      myStorage.set('sSymbolName', defaultSymbol);
    }
  } catch (err) {
    // 设置默认默认币对错误,很可能是当前还没有币对
    console.log(err);
  }
};
